import React from "react"

export default function CardLayout({ children }) {
  return (
    <div className="bg-white p-5 rounded-2xl overflow-hidden shadow-xl">
      <div className="m-5">{children}</div>
    </div>
  )
}
